import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Importação do Link
import { BiMenu, BiX } from 'react-icons/bi';
import logo from '../assets/images/lfdeveloper.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false); // Estado para controlar o submenu

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  return (
    <header id="header" className="fixed-top bg-light shadow-sm">
      <div className="container d-flex align-items-center justify-content-between py-2">
        {/* Logo */}
        <h1 className="logo m-0">
          <Link to="/">
            <img width="180px" src={logo} alt="LF Developer Logo" />
          </Link>
        </h1>

        {/* Menu Desktop */}
        <nav className={`navbar navbar-expand-lg ${isOpen ? 'show' : ''}`}>
          <ul className={`navbar-nav d-none d-lg-flex gap-3`}>
            <li><a className="nav-link scrollto" href="#home">Página Inicial</a></li>
            <li><a className="nav-link scrollto" href="#about">Sobre</a></li>
            <li><a className="nav-link scrollto" href="#services">Serviços</a></li>
            <li><a className="nav-link scrollto" href="#why-us">Por que nós?</a></li>
            <li><a className="nav-link scrollto" href="#technologies">Tecnologias</a></li>
            <li><a className="nav-link scrollto" href="#faq">FAQ</a></li>
            <li><a className="nav-link scrollto" href="#contact">Contato</a></li>
            
          </ul>
        </nav>

        {/* Botão Mobile */}
        <button
          onClick={toggleMenu}
          className="btn btn-outline-primary d-lg-none border-0"
          aria-label="Menu"
        >
          {isOpen ? <BiX size={32} /> : <BiMenu size={32} />}
        </button>

        {/* Menu Mobile */}
        {isOpen && (
          <div className="mobile-menu position-absolute top-100 start-0 w-100 bg-white shadow-sm d-lg-none">
            <ul className="list-unstyled text-center py-3">
              <li><a className="nav-link scrollto py-2 d-block" href="./" onClick={toggleMenu}>Página Inicial</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#about" onClick={toggleMenu}>Sobre</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#services" onClick={toggleMenu}>Serviços</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#why-us" onClick={toggleMenu}>Por que nós</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#technologies" onClick={toggleMenu}>Tecnologias</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#faq" onClick={toggleMenu}>FAQ</a></li>
              <li><a className="nav-link scrollto py-2 d-block" href="#contact" onClick={toggleMenu}>Contato</a></li>
             
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}

export default Navbar;
